import Amplify, { Auth } from 'aws-amplify';
import awsmobile from '../aws-exports';
//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
  state: {
    user_location: null,
    user_ip: null,
    user_allow_recWin: []
  },
  mutations: {
    updateUserLocation(state, user_location) {
      state.user_location = user_location;
    },
    updateUserIP(state, user_ip) {
      state.user_ip = user_ip;
    },
    updateUserAllowRecWin(state, rec_win) {
        if (!state.user_allow_recWin.includes(rec_win))
        {
           state.user_allow_recWin.push(rec_win);
        }
    },
  },
  actions: {
    async checkUserLocation({ commit}) {
      var ips = [];
      var req = [];
      var t_ip = "";
      var t_loc = "";
      req.push('OFFICE_IP');
      //await api.post("/api/w/masterData",{groups: req})
      await newAPIPost("/api/w/masterData",{groups: req})
             .then( (res) => {
               ips = res;
               //console.log(`ips from db: ${JSON.stringify(ips)}`);
             })
             .then( () => {
                 fetch('https://api.ipify.org?format=json')
                  .then(x => x.json())
                   .then(({ ip }) => {
                     //console.log(`compare ip with master data from vuex`);
                     console.log(`ips: ${JSON.stringify(ips)}`);
                     //var login_office_info = ips.filter((it) => it.tagName == ip);
                     var login_office_info = [];
                     if (ips && ips.length > 0)
                     {
                        login_office_info = ips.filter((it) => it.tagName == ip);
                     }
                     console.log(`login office info: ${JSON.stringify(login_office_info)}`);
                     var login_office = "";
                     if (login_office_info && login_office_info.length > 0)
                     {
                        login_office = login_office_info[0].tagId;
                        t_loc = login_office;
                        //console.log(`t_loc: ${t_loc}`);
                        commit('updateUserLocation', t_loc);
                     }
                     //console.log(`office_ips: ${this.user_location}`);
                     t_ip = ip;
                     //console.log(`ip: ${ip} t_ip: ${t_ip}`);
                     commit('updateUserIP', t_ip);
                     //return ip;
                    //return ip;
                  }) 
                  .then(() => {
                    var p_groups = [];
                    //var p_rec_wins = [];
                    p_groups.push("OFFICE_IP");
                    p_groups.push("ALLOW_REC_WIN");
                    //console.log(`get office ip and allow rec win`);
                    var offices = [];
                    var recwins = [];
                    //api.post("/api/w/masterData",{groups: p_groups})
                    newAPIPost("/api/w/masterData",{groups: p_groups})
                    .then((res) => {
                       //console.log(`t_loc: ${t_loc}`);
                       if (res && res.length > 0)
                       { 
                         offices = res.filter(it => it.group == 'OFFICE_IP' && it.tagId == t_loc && it.active == true);
                         recwins = res.filter(it => it.group == 'ALLOW_REC_WIN' && it.location == t_loc && it.active == true)
                       }
                       //console.log(`offices: ${JSON.stringify(offices)}`);
                       //console.log(`recwins: ${JSON.stringify(recwins)}`);
                       recwins.forEach((it) => {
                          //console.log(`inject rec win`);
                          commit('updateUserAllowRecWin', it.recWindow);
                       })
                    })
                  });
             });

    },
  },
  getters: {
    getUserLocation : state => state.user_location,
    getUserIP: state => state.user_ip,
    getUserAllowRecWin: state => state.user_allow_recWin,
  },
};
